var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.74621 8.48136C8.43941 8.77524 8.43941 9.25171 8.74621 9.54558C9.053 9.83946 9.55042 9.83946 9.85721 9.54558L14.0471 5.53215C14.2005 5.38521 14.2772 5.19262 14.2772 5.00003C14.2772 4.898 14.256 4.80071 14.2176 4.71198C14.1792 4.62323 14.1224 4.54007 14.0471 4.46792L9.85721 0.454484C9.55042 0.160607 9.053 0.160607 8.74621 0.454484C8.43941 0.748362 8.43941 1.22483 8.74621 1.51871L11.595 4.24751L1.44574 4.24752C1.01186 4.24752 0.660139 4.58443 0.660139 5.00004C0.660139 5.41564 1.01186 5.75255 1.44574 5.75255L11.595 5.75255L8.74621 8.48136Z",
    fill: "#F45045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowRed);
export default __webpack_public_path__ + "static/media/rightArrowRed.d24377ca6b3d67c033a03b9082a7fdf6.svg";
export { ForwardRef as ReactComponent };